import { Component, Input } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'number-keyboard',
  templateUrl: 'numberKeyboard.html',
  styleUrls: ["./numberKeyboard.scss"]
})
export class NumberKeyboard {
  @Input() hideOnSubmit: boolean = true;
  @Input() canSubmit: boolean = true;

  showingUpdated: BehaviorSubject<boolean>;
  showing: boolean;
  onChar: (key: string) => any;
  onBackspace: () => any;
  onSubmit: () => any;

  constructor() {
    this.showing = false;
    this.showingUpdated = new BehaviorSubject<boolean>(false);
  }

  show() {
    this.showing = true;
    this.showingUpdated.next(true);
  }

  hide() {
    this.showing = false;
    this.showingUpdated.next(false);
  }

  keyPressed(key: string) {
    if(this.onChar)
      this.onChar(key);
  }

  backspace() {
    if(this.onBackspace)
      this.onBackspace();
  }

  submit() {
    if(!this.canSubmit)
      return;
    if(this.hideOnSubmit)
      this.hide();
    if(this.onBackspace)
      this.onSubmit();
  }
}
